export const proteins = [
  {
    'chicken breast': {
      servingSize: '3 ounces',
      calories: 141.4,
      protein: 26.3,
      carbs: 0,
      fats: 3,
    },
  },
  {
    'ground turkey': {
      servingSize: '3 ounces',
      calories: 219.5,
      protein: 21.5,
      carbs: 0,
      fats: 15,
    },
  },
  {
    'protein bar': {
      servingSize: '1',
      calories: 216.3,
      protein: 19.9,
      carbs: 20.8,
      fats: 5.1,
    },
  },
  {
    "Siggi's whole milk plain yogurt": {
      servingSize: '2/3 cup',
      calories: 170,
      protein: 18,
      carbs: 8,
      fats: 7,
    },
  },
  {
    'boiled egg': {
      servingSize: '1',
      calories: 75.2,
      protein: 6.3,
      carbs: 0.6,
      fats: 5.2,
    },
  },
  {
    shrimp: {
      servingSize: '3 ounces',
      calories: 101.2,
      protein: 19.2,
      carbs: 1.3,
      fats: 1.5,
    },
  },
  {
    salmon: {
      servingSize: '3 ounces',
      calories: 177.5,
      protein: 18.7,
      carbs: 0,
      fats: 10.3,
    },
  },
];
export const fats = [
  {
    avocado: {
      servingSize: '1',
      calories: 227.3,
      protein: 2.7,
      carbs: 11.7,
      fats: 21.2,
    },
  },
  {
    cashews: {
      servingSize: '1 ounce',
      calories: 158.4,
      protein: 4.3,
      carbs: 9.1,
      fats: 13.1,
    },
  },
  {
    almonds: {
      servingSize: '1 ounce',
      calories: 171.1,
      protein: 5.9,
      carbs: 6,
      fats: 14.9,
    },
  },
  {
    'extra virgin olive oil': {
      servingSize: '1 tablespoon',
      calories: 120.8,
      protein: 0,
      carbs: 0,
      fats: 13.7,
    },
  },
  {
    'sunflower seeds': {
      servingSize: '1 ounce',
      calories: 157.3,
      protein: 5.5,
      carbs: 4.4,
      fats: 14.4,
    },
  },
  {
    'boiled egg': {
      servingSize: '1',
      calories: 75.2,
      protein: 6.3,
      carbs: 0.6,
      fats: 5.2,
    },
  },
  {
    salmon: {
      servingSize: '3 ounces',
      calories: 177.5,
      protein: 18.7,
      carbs: 0,
      fats: 10.3,
    },
  },
];
export const carbs = [
  {
    date: {
      servingSize: '1',
      calories: 20.5,
      protein: 0.2,
      carbs: 5.4,
      fats: 0,
    },
  },
  {
    banana: {
      servingSize: '1',
      calories: 105.5,
      protein: 1.3,
      carbs: 27.4,
      fats: 0.4,
    },
  },
  {
    strawberry: {
      servingSize: '2',
      calories: 56.3,
      protein: 1.2,
      carbs: 13.7,
      fats: 0.5,
    },
  },
  {
    oatmeal: {
      servingSize: '2 cups',
      calories: 325.6,
      protein: 11.8,
      carbs: 55.1,
      fats: 7,
    },
  },
  {
    quinoa: {
      servingSize: '1 cup',
      calories: 112.7,
      protein: 4.1,
      carbs: 19.4,
      fats: 1.8,
    },
  },
  {
    toast: {
      servingSize: '1 slice',
      calories: 65.6,
      protein: 2,
      carbs: 11.9,
      fats: 0.9,
    },
  },
  {
    rice: {
      servingSize: '1 cup',
      calories: 201.3,
      protein: 4.2,
      carbs: 44.9,
      fats: 0.4,
    },
  },
];
